import { Component, ElementRef, ViewChild, Injector, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { getMonthName } from '../../../core/helper/month';
import { getTranslation } from '../../../core/helper/translation';
import { Image } from '../../../core/model/image';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FileService } from '../../../core/service/file.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand, Command } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { LanguageService } from '../../../core/service/language.service';
import { CreditInstitute } from '../../../common/model/credit-institute';
import { CreditInstituteService } from '../../service/credit-institute.service';
import { ContactIdKind } from '../../../rent/model/contact';
import { CompanyService } from '../../../rent/service/data/company.service';
import { SelectionItem } from '../../../core/component/select/select.component';

@Component({
    selector: 'app-credit-institute-form',
    templateUrl: './credit-institute-form.component.html',
    styleUrls: ['./credit-institute-form.component.scss'],
    providers: [{ provide: DataService, useExisting: CreditInstituteService }, DeleteFormCommandHandler, FormCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditInstituteFormComponent extends FormComponentBase<CreditInstitute> {
  constructor(
    private _dataService: CreditInstituteService,
    private _cf: FormControlExFactory,
    private _fb: FormBuilder,
    private _languageService: LanguageService,
    private _route: ActivatedRoute,
    private _companyService: CompanyService,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(_route, _dataService, messageService, navigation, commandDispatcher, handlerResolver);
    this.countries = this._companyService.getBusinessCountryCultureSelection();
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  countries: SelectionItem[];

  protected createModel(): CreditInstitute {
    return new CreditInstitute();
  }

  get idType(): ContactIdKind {
    if (!this.form || !this.form.controls['cultureName'].value) {
      return ContactIdKind.SwedishOrganizationNumber;
    }
    switch (this.form.controls['cultureName'].value) {
      case 'da-DK':
        return ContactIdKind.DanishOrganizationNumber;
      case 'fi-FI':
        return ContactIdKind.FinnishOrganizationNumber;
      default:
        return ContactIdKind.SwedishOrganizationNumber;
    }
  }

  protected getFormGroup(): FormGroup {
    let group = this._fb.group({
      id: this._cf.createHidden(this.dataContext.id),
      cultureName: this._cf.createMandatory('COMPANY.ACTIVE_IN_COUNTRY', this.dataContext.cultureName),
      name: this._cf.createMandatory('MORTGAGE.COMPANY_MORTGAGE_NAME', this.dataContext.name),
      organizationNumber: this._cf.createMandatory('COMPANY.ORGANIZATION_NUMBER', this.dataContext.organizationNumber),
      postalAddress: this._fb.group({}),
    });
    return group;
  }
}
